module.exports = __webpack_public_path__ + "tw.9374cc29.svg";